import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import { IdGen } from 'utils'

import * as SaldosInicialesService from 'services/saldosIniciales.service'

import MainForm from './mainForm'

const NuevoSaldoInicial = ({ match }) => {
  const __zariContext = React.useContext(ZariContext)

  const [__keyMainForm, setKeyMainForm] = React.useState(null)

  const editarDataRef = React.useRef({})

  const portletBreadcrumbs = React.useMemo(() => {
    if (match.params.id) {
      return [{ name: 'Saldos Iniciales', path: `/${CodigosTransaccionesConstant.SALDOSINICIALES_LISTA}` }, { name: 'Editar' }]
    }
    return [{ name: 'Saldos Iniciales', path: `/${CodigosTransaccionesConstant.SALDOSINICIALES_LISTA}` }, { name: 'Nuevo' }]
  }, [match.params.id])

  React.useEffect(() => {
    if (match.params.id) {
      SaldosInicialesService.obtenerxIdAsEdicion(match.params.id)
        .then(({ data }) => {
          editarDataRef.current = data
          setKeyMainForm(IdGen.newId())
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      setKeyMainForm(IdGen.newId())
    }
  }, [match.params, __zariContext])

  return (
    <Portlet>
      <Portlet.Header title='Saldos Iniciales' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>{__keyMainForm && <MainForm key={__keyMainForm} editarData={editarDataRef.current} />}</Portlet.Body>
    </Portlet>
  )
}

export default NuevoSaldoInicial
